import Policy from '@/models/Policy';
import IPolicyState from './interfaces/policy-state.d';

export default class PolicyState implements IPolicyState {
  public defaultPhoneMicroCopy: string = 'We\'ll only use this number to progress your enquiry';

  public defaultEmailMicroCopy: string = 'We\'ll send you a confirmation email.';

  public servicePolicy: Policy = new Policy();

  public marketingPolicyVersionId!: string;

  public optInText: string | null = null;

  public partnerMarketingPolicyVersionId!: string;

  public fCAPolicyVersionId!: string;

  public partnerPolicyText: string | null = null;

  public privacyPolicyVersionId!: string;

  public termsPolicyVersionId!: string;
}
